import { useMutation } from "@tanstack/react-query";
import { requestURLs } from "../../Environment";
import {
  AxiosResponseAndError,
  ResponseType,
} from "@/api/types/axiosResponseType";
import ApiRequest from "../ApiRequest";
import { checkoutSchema } from "@backend/src/schemas/paymentSchema";
import { BillingCycleSchema } from "@backend/src/schemas/enums";
import z from "zod";
export type paymentCheckout = {
  id: string;
  url: string;
  client_secret: string;
  billingCycle: keyof typeof BillingCycleSchema;
};

type paymentCheckoutResponse = ResponseType<paymentCheckout>;

function useSingleReadNotificationMutation() {
  const mutation = useMutation<
    AxiosResponseAndError<paymentCheckoutResponse>["response"],
    AxiosResponseAndError<paymentCheckoutResponse>["error"],
    z.infer<typeof checkoutSchema>
  >({
    mutationFn: (data) =>
      ApiRequest.post<paymentCheckoutResponse>(
        `${requestURLs.paymentCheckout}`,
        data
      ),
  });

  return mutation;
}
export default useSingleReadNotificationMutation;
